import { render, staticRenderFns } from "./SingleDevice.vue?vue&type=template&id=452f06ec&"
import script from "./SingleDevice.vue?vue&type=script&lang=js&"
export * from "./SingleDevice.vue?vue&type=script&lang=js&"
import style0 from "./SingleDevice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports